import styled from 'styled-components'

import { FlexCentered } from 'components/common/genericStyles'
import { EndCallButtonStyle as _EndCallButtonStyle } from 'components/Controls/styles'
import { Color } from 'constants/color'

export const EndCallButtonStyle = styled(_EndCallButtonStyle)`
    ${FlexCentered};

    width: 56px !important;
    height: 40px !important;
    background-color: ${Color.unknownColor19};
    padding: 12px 20px;
    margin-top: 0 !important;
    margin: 0;
    border-radius: 44px;
    cursor: pointer;
    border: none;
`
